import css from 'styled-jsx/css';

const styles = css.global`#renegociacao25-entenda {
  padding-bottom: 40px;
}

#renegociacao25-entenda .entenda-conteudo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 40px 0;
}

#renegociacao25-entenda .entenda-conteudo img {
  display: flex;
  width: 180px;
  height: 180px;
  justify-content: center;
  align-items: center;
}

#renegociacao25-entenda .entenda-conteudo .entenda-textos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#renegociacao25-entenda .entenda-conteudo .entenda-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px; 
}

#renegociacao25-entenda .entenda-conteudo .entenda-texto {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

#renegociacao25-entenda .entenda-conteudo .entenda-texto b {
  font-weight: 800;
}

#renegociacao25-entenda .entenda-quadros {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

#renegociacao25-entenda .entenda-quadros .entenda-quadro {
  display: flex;
  padding: 33px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 33px;
  align-self: stretch;
  border-radius: 4px;
  background: #DEEDF2;
  position: relative;
  width: 100%;
}

#renegociacao25-entenda .entenda-quadros .entenda-quadro.quadro-2 {
  padding: 32px 8px 32px 24px;
}

#renegociacao25-entenda .entenda-quadro .entenda-quadro-textos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#renegociacao25-entenda .entenda-quadro .entenda-quadro-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#renegociacao25-entenda .entenda-quadro .entenda-quadro-texto b {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

#renegociacao25-entenda .entenda-quadro .entenda-quadro-texto strong {
  color: #444;
  font-family: "SantanderText";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
}

#renegociacao25-entenda .entenda-quadro .entenda-quadro-link {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  padding: 8px;
}

#renegociacao25-entenda .entenda-quadros .entenda-quadro-separador.desktop {
  display: none;
}
 
#renegociacao25-entenda .entenda-quadros .entenda-quadro-separador {
  color: #C00;
  font-family: "SantanderText";
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  position: absolute;
  left: 50%;
  bottom: -26px;
  transform: translate(-50%, 0);
  z-index: 2;
}

@media (min-width: 992px) {
  #renegociacao25-entenda {
    margin-top: 0;
    padding-bottom: 56px;
  }

  #renegociacao25-entenda .entenda-conteudo {
    flex-direction: row;
    gap: 32px;
  }
  
  #renegociacao25-entenda .entenda-conteudo img {
    width: 256px;
    height: 256px;
  }

  #renegociacao25-entenda .entenda-conteudo .entenda-titulo {
    font-size: 56px;
    line-height: 120%; 
  }
  
  #renegociacao25-entenda .entenda-conteudo .entenda-texto {
    font-size: 24px;
    line-height: 36px;
  }

  #renegociacao25-entenda .entenda-quadros {
    flex-direction: row;
    gap: 24px;
    justify-content: center;
  }

  #renegociacao25-entenda .entenda-quadros .entenda-quadro-separador.desktop {
    display: block;
    position: initial;
    transform: none;
  }
   
  #renegociacao25-entenda .entenda-quadros .entenda-quadro-separador {
    display: none;
  }

  #renegociacao25-entenda .entenda-quadros .entenda-quadro {
    max-width: 540px;
  }
}`;

export default styles;